import pluralize from 'pluralize'

export const convertMonthToYear = (value: string) =>
    Math.round(Number(value) / 12).toString()

export const convertYearToMonth = (value: string) =>
    (Number(value) * 12).toString()

export const formatLoanTermYears = (loanTerm?: string | number): string => {
    if (!loanTerm) {
        return ''
    }

    const termInYears = convertMonthToYear(loanTerm.toString())

    return `${termInYears} ${pluralize('year', Number(termInYears))}`
}

export const formatLoanTermYearsAndMonths = (
    loanTerm?: string | number
): string => {
    if (!loanTerm) {
        return ''
    }

    const months = Number(loanTerm)
    const years = Math.floor(months / 12)
    const remainingMonths = months % 12

    if (months < 12) {
        return `${months} ${pluralize('month', months)}`
    }

    if (remainingMonths === 0) {
        return `${years} ${pluralize('year', years)}`
    }

    return `${years}${pluralize('yr', years)} ${remainingMonths}m`
}
